/* theme.product.js — split verbatim from Shrine main.js (deobfuscated 2026-10-14).
   Load order: theme.core → theme.cart → theme.search → theme.product → theme.deals → theme.extras → theme.license-guard. */

!customElements.get("product-form") && customElements.define("product-form", class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.handleSubmit.bind(this));
    this.formIdInput = this.form.querySelector("[name=id]");
    this.formIdInput.disabled = false;
    this.isMain = this.classList.contains("main-product-form");
    this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [];
    this.skipCart = this.formIdInput.dataset.skipCart === "true";
    this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
    this.isCartUpsell = this.dataset.isCartUpsell === "true";
    this.submitButton = this.querySelector("[type=\"submit\"]");
    if (document.querySelector("cart-drawer")) {
      if (this.submitButton) this.submitButton.setAttribute("aria-haspopup", "dialog");
      this.hasDrawer = true;
    }
    if (this.submitButton) this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
    this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section);
    this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
    this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    if (this.quantityBreaks) this.quantityBreakUpsells = this.quantityBreaks.querySelectorAll("quantity-break-upsells");
    this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
    this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
    this.variantInputs = this.form.querySelector(".product-form__variants");
  }
  handleSubmit(event) {
    let value = null,
      flag = false;
    event && (event.preventDefault(), event.currentTarget.classList.contains("button--has-spinner") && (value = event.currentTarget, value.classList.add("loading")), event.currentTarget.dataset.skipCartButton === "true" && (flag = true));
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.handleErrorMessage();
    this.submitButton.setAttribute("aria-disabled", true);
    if (!value) {
      this.submitButton.classList.add("loading");
      if (this.loadingSpinner) this.loadingSpinner.classList.remove("hidden");
    }
    this.additionalAtcButtons.forEach(item => {
      item.setAttribute("disabled", "");
    });
    this.displayedSubmitButton && (this.displayedSubmitButton.setAttribute("disabled", ""), this.displayedSubmitButton.classList.add("loading"));
    let flag2 = false,
      flag3 = false;
    if (this.variantInputs && !this.ref) {
      this.variantInputs.innerHTML = "";
      let str = "";
      const arr = [],
        set = new Set(),
        callback = arg => {
          const str2 = arg == null ? "" : String(arg).trim();
          return str2 === "" ? null : str2;
        },
        callback2 = (arg, arg2 = 1, arg3 = null) => {
          if (!arg) return;
          const stringResult = String(arg),
            numberResult = Number(arg2) || 1,
            callbackResult = callback(arg3),
            index = arr.findIndex(item => {
              const callbackResult2 = callback(item.selling_plan);
              return item.id === stringResult && callbackResult2 === callbackResult;
            });
          if (index === -1) {
            const obj = {
              id: stringResult,
              quantity: numberResult
            };
            if (callbackResult) obj.selling_plan = callbackResult;
            arr.push(obj);
          } else arr[index].quantity += numberResult;
        },
        callback3 = arg => {
          if (arg) set.add(String(arg));
        };
      this.hasDrawer && !this.isCartUpsell && !this.skipCart && this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(item => {
        if (item.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + item.dataset.handle)) {
          const value2 = item.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
          callback2(item.dataset.id, 1, value2);
        }
      });
      if (this.bundleDeals) {
        this.dataset.includePdpUpsells === "true" && document.querySelectorAll("product-info-upsell").forEach(item => {
          const value2 = item.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
          if (item.dataset.selected === "true") callback2(item.dataset.id, 1, value2);
        });
        (this.bundleDeals.formVariants || []).forEach(item => {
          if (!item) return;
          callback2(item.id, Number(item.quantity) || 1);
        });
      } else {
        this.quantityGifts && Array.isArray(this.quantityGifts.unlockedItems) && this.quantityGifts.unlockedItems.length > 0 && this.quantityGifts.unlockedItems.forEach(item => callback2(item, 1));
        this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
        for (let value2 = this.upsells.length - 1; value2 >= 0; value2--) {
          const item = this.upsells[value2];
          if (item && item.dataset.selected === "true") {
            const value3 = item.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
            callback2(item.dataset.id, 1, value3);
          }
        }
        this.quantityBreakUpsells && this.quantityBreakUpsells.forEach(item => {
          (item.unlockedItems || []).forEach(item2 => {
            const stringResult = String(item2);
            !arr.some(item3 => String(item3.id) === stringResult) && callback2(stringResult, 1);
          });
        });
        if (this.mainBundleItems.length === 0) {
          if (this.quantityBreaks && Array.isArray(this.quantityBreaks.formVariants) && this.quantityBreaks.formVariants.length > 0) {
            this.quantityBreaks.formVariants.forEach(item => {
              callback2(item, 1);
              callback3(item);
            });
            flag3 = true;
          } else {
            let num = 1;
            if (this.quantityBreaks) num = Number(this.quantityBreaks.selectedQuantity) || 1;else {
              if (this.quantityPicker) num = Number(this.quantityPicker.querySelector(".quantity__input")?.["value"]) || 1;else this.querySelector("input[name=\"quantity\"]") && (num = Number(this.querySelector("input[name=\"quantity\"]").value) || 1);
            }
            const value2 = this.formIdInput.value;
            callback2(value2, num);
            callback3(value2);
          }
        }
        for (let value2 = this.mainBundleItems.length - 1; value2 >= 0; value2--) {
          const item = this.mainBundleItems[value2];
          callback2(item.dataset.id, 1);
          (item.dataset.isMainPdpProduct === undefined || item.dataset.isMainPdpProduct === "true") && callback3(item.dataset.id);
        }
      }
      if (arr.length > 1 || flag3 || this.bundleDeals || this.mainBundleItems.length > 0) {
        const arr2 = [];
        this.customFields?.["forEach"](arg => {
          arg?.["dataset"]?.["disabled"] !== "true" && arr2.push({
            fieldName: arg.fieldName,
            value: arg.prevValue
          });
        });
        let value2 = null;
        this.classList.contains("main-product-form") && (value2 = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"], skio-plan-picker [name=\"selling_plan\"]"));
        const el = this.querySelector("#simple-bundles-io-options"),
          value3 = "input[name^=\"properties[\"]:not(#validator):not(.shrine-property-input):not([type=\"radio\"]),input[name^=\"properties[\"][type=\"radio\"]:checked:not(#validator):not(.shrine-property-input),select[name^=\"properties[\"]:not(#validator):not(.shrine-property-input)",
          els = this.classList.contains("main-product-form") ? this.productInfo ? this.productInfo.querySelectorAll(value3) : document.querySelectorAll(value3) : [];
        arr.forEach(item => {
          if (set.has(item.id)) {
            const arr4 = [];
            arr2.forEach(item2 => {
              arr4.push({
                fieldName: item2.fieldName,
                value: item2.value
              });
            });
            el && el.querySelectorAll("select[name^=\"properties[\"], input[name^=\"properties[\"]").forEach(item2 => {
              const match = item2.name.match(/properties\[(.*?)\]/);
              if (match) arr4.push({
                fieldName: match[1],
                value: item2.value
              });
            });
            this.classList.contains("main-product-form") && els.forEach(item2 => {
              const match = item2.name.match(/properties\[(.*?)\]/);
              match && (item2.type === "file" ? item2.files && item2.files.length > 0 && arr4.push({
                fieldName: match[1],
                value: item2.files[0],
                isFile: true
              }) : arr4.push({
                fieldName: match[1],
                value: item2.value
              }));
            });
            if (arr4.length) item.properties = arr4;
            value2 && typeof value2.value === "string" && value2.value.length > 0 && (item.selling_plan = value2.value);
          }
        });
        const fragment = document.createDocumentFragment(),
          arr3 = [];
        arr.forEach((item, index) => {
          str += "<input type=\"hidden\" name=\"items[" + index + "][quantity]\" value=\"" + item.quantity + "\">" + ("<input type=\"hidden\" name=\"items[" + index + "][id]\" value=\"" + item.id + "\">");
          item.selling_plan && (str += "<input type=\"hidden\" name=\"items[" + index + "][selling_plan]\" value=\"" + item.selling_plan + "\">");
          Array.isArray(item.properties) && item.properties.length && item.properties.forEach(item2 => {
            if (item2.isFile) arr3.push({
              name: "items[" + index + "][properties][" + item2.fieldName + "]",
              file: item2.value
            });else {
              const el2 = document.createElement("input");
              el2.type = "hidden";
              el2.name = "items[" + index + "][properties][" + item2.fieldName + "]";
              el2.value = serializePropValue(item2.value);
              fragment.appendChild(el2);
            }
          });
        });
        this._filePropsForFormData = arr3;
        this.variantInputs.innerHTML = str;
        this.variantInputs.appendChild(fragment);
        flag2 = true;
      }
    }
    var fetchConfigResult = fetchConfig("javascript");
    fetchConfigResult.headers["X-Requested-With"] = "XMLHttpRequest";
    delete fetchConfigResult.headers["Content-Type"];
    var formData = new FormData(this.form);
    this._filePropsForFormData && this._filePropsForFormData.length > 0 && (this._filePropsForFormData.forEach(({
      name: item,
      file: item2
    }) => {
      formData.append(item, item2);
    }), this._filePropsForFormData = []);
    if (this.ref) flag2 = true;
    this.cart && (formData.append("sections", this.cart.getSectionsToRender().map(item => item.id)), formData.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement));
    if (flag2) {
      const parts = this.dataset.options ? this.dataset.options.split(",") : [],
        arr = ["id", "quantity", ...parts];
      for (let num = 0; num < arr.length; num++) {
        formData["delete"](arr[num]);
      }
    }
    fetchConfigResult.body = formData;
    fetch("" + routes.cart_add_url, fetchConfigResult).then(result => result.json()).then(async result => {
      if (result.status) {
        this.handleErrorMessage(result.description);
        const el = this.submitButton.querySelector(".sold-out-message");
        if (!el) return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.querySelector("span").classList.add("hidden");
        el.classList.remove("hidden");
        this.error = true;
        return;
      }
      if (!result.sections && this.cart) try {
        const response = await fetch(routes.cart_url + "?sections=" + this.cart.getSectionsToRender().map(item => item.id).join(",")),
          text = await response.text();
        try {
          const data = JSON.parse(text);
          result.sections = data;
        } catch (error) {
          console.error("Add to cart fallback JSON parse failed", error);
          window.location = window.routes.cart_url;
          return;
        }
      } catch (error) {
        console.error("Add to cart fallback failed", error);
        this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
        return;
      }
      if (this.skipCart || flag) {
        window.location = "/checkout";
        return;
      } else {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
      }
      if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: this.formIdInput.id,
        cartData: result
      });
      this.error = false;
      const parentEl = this.closest("quick-add-modal");
      parentEl ? (document.body.addEventListener("modalClosed", () => {
        setTimeout(() => {
          this.cart.renderContents(result, this.isCartUpsell);
        });
      }, {
        once: true
      }), parentEl.hide(true)) : this.cart.renderContents(result, this.isCartUpsell);
    })["catch"](arg => {
      console.error(arg);
    })["finally"](() => {
      if (value) value.classList.remove("loading");else {
        this.submitButton.classList.remove("loading");
        if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
      }
      this.additionalAtcButtons.forEach(item => {
        item.removeAttribute("disabled");
      });
      this.displayedSubmitButton && (this.displayedSubmitButton.removeAttribute("disabled"), this.displayedSubmitButton.classList.remove("loading"));
      if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    });
  }
  handleErrorMessage(arg = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
    this.errorMessageWrapper.toggleAttribute("hidden", !arg);
    arg && (this.errorMessage.textContent = arg);
  }
});
!customElements.get("product-info") && customElements.define("product-info", class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = document.querySelector("[" + defMed + "]");
    this.input = this.querySelector(".quantity__input");
    this.currentVariant = this.querySelector(".product-variant-id");
    this.variantSelects = this.querySelector("variant-radios");
    this.submitButton = this.querySelector("[type=\"submit\"]");
    this.form = this.querySelector("#ProductForm-" + this.dataset.section);
    this.hasUrl = this.dataset.url !== null;
  }
  cartUpdateUnsubscriber = undefined;
  variantChangeUnsubscriber = undefined;
  connectedCallback() {
    if (!this.form) return;
    if (!this.input) return;
    this.quantityForm = this.querySelector(".product-form__quantity");
    if (!this.quantityForm) return;
    this.setQuantityBoundries();
    !this.dataset.originalSection && (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this)));
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, arg => {
      const originalSection = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      if (arg.data.sectionId !== originalSection) return;
      this.updateQuantityRules(arg.data.sectionId, arg.data.html);
      this.setQuantityBoundries();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
  }
  setQuantityBoundries() {
    const obj = {
      cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
      min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
      max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
      step: this.input.step ? parseInt(this.input.step) : 1
    };
    let min = obj.min;
    const max = obj.max === null ? obj.max : obj.max - obj.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (obj.cartQuantity >= obj.min) min = Math.min(min, obj.step);
    const parseIntResult = parseInt(this.input.value) || min;
    let value = parseIntResult;
    if (value < min) value = min;
    if (max !== null && value > max) value = max;
    this.input.min = min;
    this.input.max = max;
    this.input.value = value;
    publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
  initShareLinks() {
    const el = this.querySelector(".share-url-button");
    if (!el) this.shareUrl = true;
  }
  fetchQuantityRules() {
    if (!this.currentVariant || !this.currentVariant.value) return;
    this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
    fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(result => {
      return result.text();
    }).then(result => {
      const parseFromString = new DOMParser().parseFromString(result, "text/html");
      this.updateQuantityRules(this.dataset.section, parseFromString);
      this.setQuantityBoundries();
    })["catch"](arg => {
      console.error(arg);
    })["finally"](() => {
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
    });
  }
  updateQuantityRules(arg, arg2) {
    const el = arg2.getElementById("Quantity-Form-" + arg);
    if (el && this.quantityForm) {
      const arr = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let value of arr) {
        const el2 = this.quantityForm.querySelector(value),
          el3 = el.querySelector(value);
        if (!el2 || !el3) continue;
        if (value === ".quantity__input") {
          const arr2 = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let value2 of arr2) {
            const attrValue = el3.getAttribute(value2);
            if (attrValue !== null) el2.setAttribute(value2, attrValue);
          }
        } else el2.innerHTML = el3.innerHTML;
      }
    }
  }
});
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || "");
    this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || "");
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener("shopify:section:load", event => {
      this.insertDates();
    });
  }
  addDaysSkipping(arg, arg2) {
    let date2 = new Date(arg),
      numberResult = Number(arg2) || 0;
    while (numberResult > 0) {
      date2 = addDays(date2, 1);
      if (!this.isSkipped(date2)) numberResult--;
    }
    return date2;
  }
  parseDaysToSkip(arg) {
    const map = new Map([["sunday", 0], ["monday", 1], ["tuesday", 2], ["wednesday", 3], ["thursday", 4], ["friday", 5], ["saturday", 6]]),
      set = new Set();
    if (!arg) return set;
    arg.split(",").forEach(item => {
      const text = item.trim();
      if (map.has(text)) set.add(map.get(text));
    });
    return set;
  }
  parseDatesToSkip(arg) {
    const set = new Set();
    if (!arg) return set;
    arg.split(",").forEach(item => {
      const text = item.trim();
      if (!text) return;
      const parts = text.split("-");
      if (parts.length === 2) {
        const padStart = String(Math.max(1, Math.min(12, Number(parts[0])))).padStart(2, "0"),
          padStart2 = String(Math.max(1, Math.min(31, Number(parts[1])))).padStart(2, "0");
        set.add(padStart + "-" + padStart2);
      } else {
        if (parts.length === 3) {
          const padStart = String(Math.max(1, Math.min(12, Number(parts[1])))).padStart(2, "0"),
            padStart2 = String(Math.max(1, Math.min(31, Number(parts[2])))).padStart(2, "0");
          set.add(padStart + "-" + padStart2);
        }
      }
    });
    return set;
  }
  isSkipped(arg) {
    const has = this.daysToSkip.has(arg.getDay()),
      padStart = String(arg.getMonth() + 1).padStart(2, "0"),
      padStart2 = String(arg.getDate()).padStart(2, "0"),
      has2 = this.datesToSkip.has(padStart + "-" + padStart2);
    return has || has2;
  }
  nextValidDate(arg) {
    let date2 = new Date(arg);
    while (this.isSkipped(date2)) {
      date2 = addDays(date2, 1);
    }
    return date2;
  }
  insertDates() {
    this.elementsToChange.forEach(item => {
      const text = item.dataset.text,
        parseIntResult = parseInt(item.dataset.minDays),
        parseIntResult2 = parseInt(item.dataset.maxDays),
        addDaysSkipping = this.addDaysSkipping(currentDate, parseIntResult),
        addDaysSkipping2 = this.addDaysSkipping(currentDate, parseIntResult2);
      let str = "th";
      const getDate = addDaysSkipping.getDate();
      if ([1, 21, 31].includes(getDate)) str = "st";else {
        if ([2, 22].includes(getDate)) str = "nd";else {
          if ([3, 23].includes(getDate)) str = "rd";
        }
      }
      let str2 = "th";
      const getDate2 = addDaysSkipping2.getDate();
      if ([1, 21, 31].includes(getDate2)) str2 = "st";else {
        if ([2, 22].includes(getDate2)) str2 = "nd";else {
          if ([3, 23].includes(getDate2)) str2 = "rd";
        }
      }
      let value, value2;
      if (this.dateFormat === "day_dd_mm") {
        value = this.days[addDaysSkipping.getDay()] + ", " + addDaysSkipping.getDate() + ". " + this.months[addDaysSkipping.getMonth()];
        value2 = this.days[addDaysSkipping2.getDay()] + ", " + addDaysSkipping2.getDate() + ". " + this.months[addDaysSkipping2.getMonth()];
      } else {
        if (this.dateFormat === "mm_dd") {
          value = this.months[addDaysSkipping.getMonth()] + " " + addDaysSkipping.getDate() + str;
          value2 = this.months[addDaysSkipping2.getMonth()] + " " + addDaysSkipping2.getDate() + str2;
        } else {
          if (this.dateFormat === "dd_mm") {
            value = addDaysSkipping.getDate() + ". " + this.months[addDaysSkipping.getMonth()];
            value2 = addDaysSkipping2.getDate() + ". " + this.months[addDaysSkipping2.getMonth()];
          } else {
            if (this.dateFormat === "dd_mm_no_dot") {
              value = addDaysSkipping.getDate() + " " + this.months[addDaysSkipping.getMonth()];
              value2 = addDaysSkipping2.getDate() + " " + this.months[addDaysSkipping2.getMonth()];
            } else {
              if (this.dateFormat === "day_dd_mm_numeric") {
                const padStart = String(addDaysSkipping.getDate()).padStart(2, "0"),
                  padStart2 = String(addDaysSkipping.getMonth() + 1).padStart(2, "0");
                value = this.days[addDaysSkipping.getDay()] + ", " + padStart + ". " + padStart2 + ".";
                const padStart3 = String(addDaysSkipping2.getDate()).padStart(2, "0"),
                  padStart4 = String(addDaysSkipping2.getMonth() + 1).padStart(2, "0");
                value2 = this.days[addDaysSkipping2.getDay()] + ", " + padStart3 + ". " + padStart4 + ".";
              } else {
                if (this.dateFormat === "dd_mm_numeric") {
                  const padStart = String(addDaysSkipping.getDate()).padStart(2, "0"),
                    padStart2 = String(addDaysSkipping.getMonth() + 1).padStart(2, "0");
                  value = padStart + ". " + padStart2 + ".";
                  const padStart3 = String(addDaysSkipping2.getDate()).padStart(2, "0"),
                    padStart4 = String(addDaysSkipping2.getMonth() + 1).padStart(2, "0");
                  value2 = padStart3 + ". " + padStart4 + ".";
                } else {
                  value = this.days[addDaysSkipping.getDay()] + ", " + this.months[addDaysSkipping.getMonth()] + " " + addDaysSkipping.getDate() + str;
                  value2 = this.days[addDaysSkipping2.getDay()] + ", " + this.months[addDaysSkipping2.getMonth()] + " " + addDaysSkipping2.getDate() + str2;
                }
              }
            }
          }
        }
      }
      const replaced = text.replace("[start_date]", value),
        replaced2 = replaced.replace("[end_date]", value2);
      item.innerHTML = replaced2;
    });
  }
  rearrangeDays(arg) {
    arg.unshift(arg[6]);
    arg.length = 7;
    return arg;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === "true" ? "after_scroll" : "always");
    this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0);
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    this.displayMode === "always" ? this.floatingBtns.forEach(item => {
      item.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
    }) : (this.checkScroll(), document.addEventListener("scroll", this.checkScroll.bind(this)));
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
    }
  }
  checkScroll() {
    let flag = false;
    if (this.displayMode === "after_scroll") {
      if (!this.mainAtcBtn) return;
      const value = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY,
        value2 = value + this.mainAtcBtn.offsetHeight;
      flag = window.scrollY > value2;
    } else {
      if (this.displayMode === "after_pixels") flag = window.scrollY > this.displayThreshold;else {
        if (this.displayMode === "after_percent") {
          const value = document.documentElement.scrollHeight - window.innerHeight;
          flag = value <= 0 ? true : window.scrollY / value * 100 > this.displayThreshold;
        }
      }
    }
    flag ? (this.style.transform = "none", this.scrolledPast = true) : (this.style.transform = "", this.scrolledPast = false);
    this.floatingBtns.forEach(item => {
      item.style.setProperty("--sticky-atc-offset", this.scrolledPast ? this.offsetHeight + "px" : "0px");
    });
  }
  handleScrollBtn() {
    const el = document.querySelector("sticky-header"),
      clientHeight = el ? el.clientHeight : 0,
      value = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: value - clientHeight - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    let el = document.querySelector(".sticky-atc-footer-spacer");
    if (el) return;
    el = document.createElement("div");
    el.className = "sticky-atc-footer-spacer";
    el.style.height = this.clientHeight - 1 + "px";
    el.style.display = "block";
    const el2 = document.querySelector(".footer");
    if (el2) el.style.background = window.getComputedStyle(el2).background;
    document.body.appendChild(el);
  }
}
customElements.define("sticky-atc", StickyAtc);
function updatePdpPrices(arg, arg2, arg3, arg4) {
  const formattedPrice = formatMoney(arg, arg4),
    formattedPrice2 = formatMoney(arg2, arg4),
    value = arg2 > arg,
    els = document.querySelectorAll(".price-" + arg3);
  els.forEach(item => {
    item.classList.toggle("price--on-sale", value);
    item.querySelector(".price__regular .price-item--regular").innerHTML = formattedPrice;
    item.querySelector(".price__sale .price-item--sale").innerHTML = formattedPrice;
    if (value) {
      const el = item.querySelector(".price__sale .price-item--regular");
      if (el) el.innerHTML = formattedPrice2;
      const el2 = item.querySelector(".badge__percentage-saved");
      if (el2) {
        const round = Math.round((arg2 - arg) * 100 / arg2);
        el2.innerHTML = round;
      }
      const el3 = item.querySelector(".badge__money-saved");
      if (el3) {
        const value2 = arg2 - arg,
          formattedPrice3 = formatMoney(value2, arg4, true);
        el3.innerHTML = formattedPrice3;
      }
    }
  });
  const els2 = document.querySelectorAll(".main-atc-price-span-" + arg3);
  els2.forEach(item => {
    item.innerHTML = formattedPrice;
  });
}
function updateVariantStatuses(arg, arg2, arg3 = false) {
  arg2.forEach((item, index) => {
    if (index === 0) return;
    const arr = [...item.querySelectorAll("option")],
      value = arg2[index - 1].querySelector(":checked").value,
      mapped = arg.filter(item2 => item2.available && item2["option" + index] === value).map(item2 => item2["option" + (index + 1)]),
      mapped2 = arg.filter(item2 => item2["option" + index] === value).map(item2 => item2["option" + (index + 1)]);
    arr.forEach(item2 => {
      item2.classList.remove("unavailable", "non-existent");
      item2.removeAttribute("disabled");
      item2.removeAttribute("hidden");
      mapped2.includes(item2.getAttribute("value")) ? mapped.includes(item2.getAttribute("value")) ? item2.innerText = item2.getAttribute("value") : (item2.innerText = window.variantStrings.unavailable_with_option.replace("[value]", item2.getAttribute("value")), item2.classList.add("unavailable"), arg3 && (item2.setAttribute("disabled", ""), item2.setAttribute("hidden", ""))) : (item2.innerText = window.variantStrings.unavailable_with_option.replace("[value]", item2.getAttribute("value")), item2.classList.add("non-existent"), item2.setAttribute("disabled", ""), item2.setAttribute("hidden", ""));
    });
  });
}
function findAvailableVariant(el, list, arg = true, arg2 = false, arg3 = false) {
  for (let value = list.length - 1; value >= 0; value--) {
    const el2 = arg ? el.querySelector(".product-form__input:nth-child(" + (value + 1) + ")") : el.querySelectorAll(".select")[value],
      type = arg ? el2.querySelector(".product-form__input__type").dataset.type : "dropdown",
      els = type === "dropdown" ? el2.querySelectorAll("option") : el2.querySelectorAll("input[type=\"radio\"]");
    let index = Array.from(els).findIndex(item => item.value === list[value]),
      flag = false;
    while (index < els.length - 1) {
      index++;
      const item = els[index];
      if ((!arg2 || !item.classList.contains("non-existent")) && (!arg3 || !item.classList.contains("unavailable"))) {
        list[value] = item.value;
        flag = true;
        break;
      }
    }
    if (!flag) {
      index = Array.from(els).findIndex(item => item.value === list[value]);
      while (index > 0) {
        index--;
        const item = els[index];
        if ((!arg2 || !item.classList.contains("non-existent")) && (!arg3 || !item.classList.contains("unavailable"))) {
          list[value] = item.value;
          flag = true;
          break;
        }
      }
    }
    if (flag) {
      type === "dropdown" ? el2.querySelector(".select__select").value = list[value] : el2.querySelector("input[type=\"radio\"][value=\"" + list[value] + "\"]").checked = true;
      el.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") this.isText = false;
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      if (this.mainAtcBtnError) this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        if (this.stickyAtcBtnError) this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) this.input.addEventListener("input", this.handleChange.bind(this));
    this.inputRadios.forEach(item => {
      item.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(arg) {
    const text = arg.target.value.trim();
    if (arg.target.checkValidity()) this.prevValue = text;else {
      arg.target.value = this.prevValue;
      return;
    }
    this.dataset.value = text;
    this.productFormInput.value = text;
    if (this.isRequired && this.isText) this.validateValue(text, arg.target);
  }
  validateValue(list, el) {
    const flag = list.length > 0 ? true : false;
    if (flag === this.isValid) return;
    this.isValid = flag;
    el && (this.isValid ? (el.classList.remove("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1) : (el.classList.add("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
    const value = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      value2 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(item => {
      value && !value2 ? item.removeAttribute("disabled") : item.setAttribute("disabled", "");
    });
    if (this.atcErrorMsg.length === 0) return;
    value ? (this.mainAtcBtnLabel.style.display = "", this.mainAtcBtnError.style.display = "none", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "", this.stickyAtcBtnError.style.display = "none")) : (this.mainAtcBtnLabel.style.display = "none", this.mainAtcBtnError.style.display = "", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "none", this.stickyAtcBtnError.style.display = ""));
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productFormInput.classList.add("shrine-property-input");
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.hasQuantityBreaksPicker && (this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle, this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages);
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const arr = [];
    this.querySelectorAll(".product-form__input").forEach(item => {
      let value;
      const type = item.querySelector(".product-form__input__type").dataset.type;
      type == "dropdown" || type == "dropdwon" ? value = item.querySelector(".select__select").value : value = item.querySelector("input[type=\"radio\"]:checked").value;
      arr.push(value);
    });
    this.options = arr;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(item => {
      return !item.options.map((item2, index) => {
        return this.options[index] === item2;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const els = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    els.forEach(item => item.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const el = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!el) return;
    const el2 = el.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    el.prepend(el2);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const el = document.getElementById("Share-" + this.dataset.section);
    if (!el || !el.updateUrl) return;
    el.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const els = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    els.forEach(item => {
      const el = item.querySelector("input[name=\"id\"]");
      el.value = this.currentVariant.id;
      el.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const filtered = this.variantData.filter(item => this.querySelector(":checked").value === item.option1);
    let value;
    this.isSecondary && this.secondarySelect ? value = [...this.secondarySelect.querySelectorAll(".product-form__input")] : value = [...this.querySelectorAll(".product-form__input")];
    value.forEach((item, index) => {
      if (index === 0) return;
      const arr = [...item.querySelectorAll("input[type=\"radio\"], .select__select option")],
        value2 = value[index - 1].querySelector(":checked").value,
        mapped = filtered.filter(item2 => item2.available && item2["option" + index] === value2).map(item2 => item2["option" + (index + 1)]),
        mapped2 = filtered.filter(item2 => item2["option" + index] === value2).map(item2 => item2["option" + (index + 1)]);
      this.setInputAvailability(arr, mapped, mapped2, this.skipNonExistent, this.skipUnavailable);
    });
  }
  setInputAvailability(arg, arg2, arg3, arg4 = false, arg5 = false) {
    arg.forEach(item => {
      item.classList.remove("unavailable", "non-existent", "disabled");
      item.removeAttribute("disabled");
      item.removeAttribute("hidden");
      const attrValue = item.getAttribute("value");
      let value = null;
      item.dataset.swatch === "true" && (value = item.closest(".color-swatch"));
      if (value) value.classList.remove("unavailable", "non-existent", "disabled");
      if (arg3.includes(attrValue)) {
        if (arg2.includes(attrValue)) {
          if (item.nodeName === "OPTION") item.innerText = attrValue;else {
            item.classList.remove("disabled");
            if (value) value.classList.remove("disabled");
          }
        } else {
          if (item.nodeName === "OPTION") {
            item.innerText = window.variantStrings.unavailable_with_option.replace("[value]", attrValue);
            item.classList.add("unavailable");
            arg5 && (item.setAttribute("disabled", ""), item.setAttribute("hidden", ""));
          } else {
            item.classList.add("disabled", "unavailable");
            if (value) value.classList.add("disabled", "unavailable");
          }
        }
      } else {
        if (item.nodeName === "OPTION") {
          item.innerText = window.variantStrings.unavailable_with_option.replace("[value]", attrValue);
          item.classList.add("non-existent");
          arg4 && (item.setAttribute("disabled", ""), item.setAttribute("hidden", ""));
        } else {
          item.classList.add("disabled", "non-existent");
          if (value) value.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const el = document.querySelector("pickup-availability");
    if (!el) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (el.fetchAvailability) el.fetchAvailability(this.currentVariant.id);
    } else {
      el.removeAttribute("available");
      el.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const parentEl = this.closest("section");
    if (!parentEl) return;
    const el = parentEl.querySelector("product-form");
    if (el) el.handleErrorMessage();
  }
  renderProductInfo() {
    const id = this.currentVariant.id,
      originalSection = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + id + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(result => result.text()).then(result => {
      if (this.currentVariant.id !== id) return;
      const parseFromString = new DOMParser().parseFromString(result, "text/html"),
        el = document.getElementById("price-" + this.dataset.section),
        el2 = parseFromString.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el3 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
        el4 = parseFromString.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el5 = document.getElementById("sticky-atc-price-" + this.dataset.section),
        el6 = parseFromString.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el7 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      if (el7 && this.currentVariant.featured_image) el7.src = this.currentVariant.featured_image.src;
      const el8 = document.getElementById("main-atc-price-" + this.dataset.section),
        el9 = parseFromString.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        els = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]"),
        els2 = parseFromString.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]"),
        el10 = parseFromString.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el11 = document.getElementById("Sku-" + this.dataset.section),
        el12 = parseFromString.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el13 = document.getElementById("Inventory-" + this.dataset.section);
      if (el && el2) el.innerHTML = el2.innerHTML;
      if (el3 && el4) el3.innerHTML = el4.innerHTML;
      if (el5 && el6) el5.innerHTML = el6.innerHTML;
      if (el9 && el8) el8.innerHTML = el9.innerHTML;
      if (els && els2) for (var num = 0; num < els.length; num++) {
        els[num].innerHTML = els2[num].innerHTML;
      }
      if (el12 && el13) el13.innerHTML = el12.innerHTML;
      el10 && el11 && (el11.innerHTML = el10.innerHTML, el11.classList.toggle("visibility-hidden", el10.classList.contains("visibility-hidden")));
      if (this.QuantityBreaks) {
        const el18 = parseFromString.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          els3 = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
          els4 = el18.querySelectorAll(".dynamic-price");
        for (let num2 = 0; num2 < els3.length; num2++) {
          els3[num2].innerHTML = els4[num2].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(item => {
            item.dataset.selectedId = this.currentVariant.id;
          });
          const els5 = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
            els6 = el18.querySelectorAll(".quantity-break__variant-select");
          for (let num2 = 0; num2 < els5.length; num2++) {
            els5[num2].innerHTML = els6[num2].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        ;
        this.currentVariant.featured_image && this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach(item => {
          item.src = this.currentVariant.featured_image.src;
        });
        this.QuantityBreaks.updatePdpPrices && (this.QuantityBreaks.dataset.basePrice = el18.dataset.basePrice, this.QuantityBreaks.labels.forEach(item => {
          item.dataset.baseComparePrice = el18.querySelector("label[data-input=\"" + item.dataset.input + "\"]").dataset.baseComparePrice;
        }), this.QuantityBreaks.initOfferPrices(true), this.QuantityBreaks.updateInnerPrices());
      }
      const el14 = document.getElementById("SubscriptionWidget-" + this.dataset.section),
        el15 = parseFromString.getElementById("SubscriptionWidget-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      if (el14) {
        if (!el15) el14.classList.add("hidden");else {
          el14.dataset.basePrice = el15.dataset.basePrice || "";
          el14.dataset.baseComparePrice = el15.dataset.baseComparePrice || "";
          const value = (el14.dataset.firstSellingPlanId || "") !== (el15.dataset.firstSellingPlanId || "");
          if (value && typeof el14.hydrateFromExternalHTML === "function") el14.hydrateFromExternalHTML(el15);else {
            const els3 = el14.querySelectorAll(".one-time-price-update"),
              els4 = el15.querySelectorAll(".one-time-price-update");
            for (let num2 = 0; num2 < els3.length; num2++) {
              els3[num2].innerHTML = els4[num2].innerHTML;
            }
            if (el14.updatePrices) el14.updateAllPrices();
          }
        }
      }
      if (this.hasQuantityBreaksPicker) {
        const el18 = parseFromString.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          els3 = this.querySelectorAll(".dynamic-price"),
          els4 = el18.querySelectorAll(".dynamic-price");
        for (let num2 = 0; num2 < els3.length; num2++) {
          els3[num2].innerHTML = els4[num2].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const els7 = this.querySelectorAll(".quantity-break__image img"),
            els8 = el18.querySelectorAll(".quantity-break__image img");
          for (let num2 = 0; num2 < els7.length; num2++) {
            els7[num2].src = els8[num2].src;
          }
        }
        const els5 = el18.querySelectorAll(".quantity-break[data-base-price]"),
          els6 = this.querySelectorAll(".quantity-break");
        for (let num2 = 0; num2 < els6.length && num2 < els5.length; num2++) {
          els5[num2].dataset.basePrice && (els6[num2].dataset.basePrice = els5[num2].dataset.basePrice, els6[num2].dataset.baseComparePrice = els5[num2].dataset.baseComparePrice);
        }
        const el19 = document.getElementById("SubscriptionWidget-" + this.dataset.section);
        el19 && el19.isSubSelected && this.updateQuantityBreaksPickerPrices && this.updateQuantityBreaksPickerPrices(el19.discountType, el19.discountValue, el19.moneyFormat);
      }
      if (this.secondarySelect) {
        const el18 = parseFromString.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (el18) this.secondarySelect.innerHTML = el18.innerHTML;
      }
      const el16 = document.getElementById("price-" + this.dataset.section);
      if (el16) el16.classList.remove("visibility-hidden");
      this.dataset.options = this.currentVariant.options.join(",");
      if (el13) el13.classList.toggle("visibility-hidden", el12.innerText === "");
      const el17 = parseFromString.getElementById("ProductSubmitButton-" + originalSection);
      this.toggleAddButton(el17 ? el17.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: originalSection,
          html: parseFromString,
          variant: this.currentVariant
        }
      });
    });
  }
  toggleAddButton(arg = true, arg2, arg3 = true) {
    const el = document.getElementById("product-form-" + this.dataset.section);
    if (!el) return;
    const el2 = el.querySelector("[name=\"add\"]");
    if (!el2) return;
    const els = document.querySelectorAll(".main-product-atc");
    var el3 = el.querySelector(".main-atc__label__text");
    if (!el3) el3 = el.querySelector(".main-atc__label");
    const el4 = el.querySelector(".main-atc-price"),
      el5 = document.querySelector(".sticky-atc__add_button");
    let value = null,
      value2 = null;
    el5 && (value = el5.querySelector(".sticky-atc__label__text"), value2 = el5.querySelector(".sticky-atc__button-price"));
    if (arg) {
      el2.setAttribute("disabled", "disabled");
      el2.setAttribute("data-unavailable", "true");
      if (arg2 && el3) el3.textContent = arg2;
      if (arg2 && value && el5.dataset.label) value.textContent = arg2;
      els.forEach(item => {
        item.setAttribute("disabled", "disabled");
      });
      if (el4) el4.classList.add("hidden");
      if (value2) value2.classList.add("hidden");
    } else {
      el2.setAttribute("data-unavailable", "false");
      const customLabel = el2.dataset.customLabel ?? window.variantStrings.addToCart;
      if (el3) el3.textContent = customLabel;
      if (el4) el4.classList.remove("hidden");
      if (value && el5.dataset.label) value.textContent = el5.dataset.label;
      if (value2) value2.classList.remove("hidden");
      el2.dataset.requiredFields === el2.dataset.validFields && (el2.removeAttribute("disabled"), els.forEach(item => {
        item.removeAttribute("disabled");
      }));
    }
    if (!arg3) return;
  }
  setUnavailable() {
    const el = document.getElementById("product-form-" + this.dataset.section);
    if (!el) return;
    const el2 = el.querySelector("[name=\"add\"]");
    var el3 = el.querySelector(".main-atc__label__text");
    if (!el3) el3 = el.querySelector(".main-atc__label");
    const el4 = document.getElementById("price-" + this.dataset.section),
      el5 = document.getElementById("Inventory-" + this.dataset.section),
      el6 = document.getElementById("Sku-" + this.dataset.section);
    if (!el2) return;
    if (el3) el3.textContent = window.variantStrings.unavailable;
    if (el4) el4.classList.add("visibility-hidden");
    if (el5) el5.classList.add("visibility-hidden");
    if (el6) el6.classList.add("visibility-hidden");
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
  updateQuantityBreaksPickerPrices(arg, arg2, arg3) {
    if (!this.hasQuantityBreaksPicker) return;
    const els = this.querySelectorAll(".quantity-break");
    if (!els.length) return;
    els.forEach(item => {
      if (!item.dataset.basePrice) return;
      const parseIntResult = parseInt(item.dataset.basePrice),
        parseIntResult2 = parseInt(item.dataset.baseComparePrice) || parseIntResult;
      let value = parseIntResult;
      if (arg && arg2) {
        if (arg === "fixed_amount") value = Math.max(0, parseIntResult - arg2);else {
          if (arg === "percentage") value = Math.round(parseIntResult * (100 - arg2) / 100);else arg === "price" && (value = arg2);
        }
      }
      const value2 = parseIntResult2 - value,
        value3 = Math.round(value2 / 100) * 100,
        round = parseIntResult2 > 0 ? Math.round(value2 / parseIntResult2 * 100) : 0,
        formattedPrice = formatMoney(value, arg3, true),
        formattedPrice2 = formatMoney(parseIntResult2, arg3, true),
        formattedPrice3 = formatMoney(value2, arg3, true),
        formattedPrice4 = formatMoney(value3, arg3, true),
        els2 = item.querySelectorAll(".variant-price-update[data-text]");
      els2.forEach(item2 => {
        let text = item2.dataset.text;
        text = text.replace("[price]", formattedPrice);
        text = text.replace("[compare_price]", formattedPrice2);
        text = text.replace("[amount_saved]", formattedPrice3);
        text = text.replace("[amount_saved_rounded]", formattedPrice4);
        text = text.replace("[percentage_saved]", round + "%");
        item2.innerHTML = text;
      });
      const el = item.querySelector(".quantity-break__compare-price");
      el && (parseIntResult2 > value ? el.classList.remove("hidden") : el.classList.add("hidden"));
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    !this.currentVariant ? (this.toggleAddButton(true, "", true), this.setUnavailable()) : (this.updateMedia(), this.updateVariantInput(), this.updateQuickAddUrl(), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const el = document.getElementById(this.dataset.section + "-image");
    if (!el) return;
    const preview_image = this.currentVariant.featured_media.preview_image,
      item = preview_image.src.split("?")[0],
      arr = [165, 360, 533, 720, 940, 1066],
      joined = arr.filter(item2 => preview_image.width >= item2).map(item2 => item + "?width=" + item2 + " " + item2 + "w").join(", ");
    el.srcset = joined + ", " + item + " " + preview_image.width + "w";
    el.src = item + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
